import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { StyleSheetManager } from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import { DatavizEmbedded } from "@radarly/models/dataviz";
import { EmbeddedError, IFrame } from "./shared";

export interface SharedWidgetsEmbeddedProps {
  dataviz: DatavizEmbedded;
  height: number;
  locale: Locale;
  disableAnimation?: boolean;
}

export default function SharedWidgetsEmbedded({
  dataviz,
  height,
  locale,
}: SharedWidgetsEmbeddedProps) {
  const [ref, setRef] = useState(null);
  const [isError, setIsError] = useState(false);
  const [_iFrameBody, _setIFrameBody] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setIsError(false);
    const data = new Image();
    data.src = dataviz.url;
    data.onerror = () => {
      setIsError(true);
    };
  }, [dataviz.url]);

  const iFrameBody = _iFrameBody ?? ref?.contentWindow?.document?.body;

  return isError ? (
    <EmbeddedError locale={locale} />
  ) : (
    <IFrame
      title={dataviz.name}
      height={height}
      ref={setRef}
      onLoad={(event) => {
        const iframe = event.target as HTMLIFrameElement;
        if (!iframe?.contentDocument) return;
        _setIFrameBody(iframe?.contentDocument.body);
      }}
    >
      {iFrameBody &&
        createPortal(
          <StyleSheetManager>
            <img
              alt={dataviz.name}
              src={dataviz?.url}
              style={{
                width: "100%",
                height: "100%",
                objectFit: dataviz.size === "fill" ? "cover" : "contain",
              }}
            />
          </StyleSheetManager>,
          iFrameBody
        )}
    </IFrame>
  );
}
